import React, {memo} from "../../../../__snowpack__/pkg/react.js";
import styled from "../../../../__snowpack__/pkg/styled-components.js";
const FixedBottomBar = memo((props) => {
  const {type, children} = props;
  return /* @__PURE__ */ React.createElement(Wrapper, {
    style: {width: "100%"}
  }, children);
});
const Wrapper = styled.div`
  position: fixed;
  z-index: 10;
  left: 0;
  bottom: 0;
  width: 100%;
  min-height: 50px;
  padding: 10px;
  background: #ffffff;
  border-top: 1px solid #d9d9d9;
  box-shadow: 0px 1px 0px 0px #d9d9d9;
  /* display: flex; */
  /* justify-content: center;
  align-items: center; */
`;
export default FixedBottomBar;
